import type { TFunction } from 'i18next'

const labelKeys: Record<string, string> = {
  crash: 'home.crashName',
  hilo: 'home.hiloName',
  hi_lo: 'home.hiloName',
  mines: 'home.minesName',
  dice: 'home.diceName',
  plinko: 'home.plinkoName',
  blast: 'home.blastName',
  blast_rooms: 'home.blastName',
  system: 'record.platform',
  admin: 'record.platform',
  dev: 'record.platform',
}

export function gameLabel(t: TFunction, game: string): string {
  const normalized = game.trim().toLowerCase().replaceAll('-', '_')
  const labelKey = labelKeys[normalized]
  return labelKey ? t(labelKey) : game
}
